module.exports = __webpack_public_path__ + "img/google-play-badge-fi.1196af77.png";